export const SOCIAL_MEDIA_INFORMATION = [
  {
    icon: "https://assets.turnoclub.com/developer/innovolt/icons/call-icon.svg",
    label: "Call us",
    content: "8970233233",
    link: "tel:8970233233",
  },
  {
    icon: "https://assets.turnoclub.com/developer/innovolt/icons/gmail-icon.svg",
    label: "Email us",
    content: "Sales@turno.club",
    link: "mailto:Sales@turno.club",
  },
];

export const COMPANY_SITE_DATA = {
  header: "Company",
  company_sites: [
    {
      label: "About",
      link: "",
    },
    {
      label: "Contact",
      link: "/aboutus",
    },
    {
      label: "Used vehicle",
      link: "/",
    },
    {
      label: "Terms & Conditions",
      // link: "https://assets.innovolt.in/policies/terms-and-conditions.pdf",
      link: "/terms-and-conditions",
    },
    {
      label: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
     label:"Refund Policy",
      // link:"https://assets.innovolt.in/policies/refund-policy.pdf",
      link: "/refund-policy",

    },
    // {
    //   label: "Vehicle Hub Locations",
    //   link: "",
    // },
    // {
    //   label: "Sitemap",
    //   link: "",
    // },
    // {
    //   label: "Blog",
    //   link: "",
    // },
  ],
};

export const COMPANY_VEHICLE_SITE_DATA = {
  header: "electric commercial vehicles",
  vehicle_sites: [
    {
      label: "Piaggio",
      link: "",
    },
    {
      label: "Mahindra",
      link: "",
    },
    {
      label: "Etrio",
      link: "",
    },
    {
      label: "Euler",
      link: "",
    },
    {
      label: "Montra Super Auto",
      link: "",
    },
    {
      label: "Piaggio E City Fx",
      link: "",
    },
    {
      label: "Bajaj RE E TEC 9.0",
      link: "",
    },
    {
      label: "Mahindra Treo Plus",
      link: "",
    },
  ],
};

export const LOCATION_INFO = [
  "Bangalore",
  "Hyderabad",
  "Lucknow",
  "Delhi",
  "Pune",
  "Kanpur",
];
